import { getCurrentInstance } from 'vue';
export default function useHttp() {
  const internalInstance = getCurrentInstance();
  const http = internalInstance.appContext.config.globalProperties.$http;
  return http;
}
